import React, { useEffect, useState, useContext } from 'react'
import { Button, Col, Divider, Drawer, Input, message, Radio, Row, Typography } from 'antd'
import debounce from 'lodash/debounce'
import Countries from '../../../../utils/countrySrc'
import Brands from '../../../../utils/brandSrc'
import Product from '../../../../utils/productCategories'
import Utils from '../../../../utils/Utils'
import CountriesSelect from '../../../../components/CountriesSelect'
import GenericSelect from '../../../../components/GenericSelect'
import { Context } from '../../../../context'
import chains from '../../../../utils/chains'
import ChainsSelect from '../../../../components/ChainsSelect'

const { Title } = Typography

function ProductDrawer(props) {
  const [{ auth }] = useContext(Context)

  // paises.
  const [countries, setCountries] = useState([])
  const [country, setCountry] = useState([])
  /// paises


  // Cadenas.
  const [StoreChains, setStoreChains] = useState([])
  const [Chains, SetChains] = useState([])
  // Cadenas.

  const [brands, setBrands] = useState([])
  const [brand, setBrand] = useState(null)
  const [productCategories, setProductCategories] = useState([])
  const [productSubCategories, setProductSubCategories] = useState([])
  const [category, setCategory] = useState(null)
  const [subCategory, setSubCategory] = useState(null)
  const [uoms, setUoms] = useState([])
  const [ActPrinciple, setActPrinciple] = useState([])
  

  const [unit, setUnit] = useState(null)
  
  const [principle1, setPrinciple1] = useState(null)
  const [principle2, setPrinciple2] = useState(null)
  const [principle3, setPrinciple3] = useState(null)
  const [price, setPrice] = useState(null)
  const [tax, setTax] = useState(true) // Declaro por defecto el impiuesto que esta activo por cambio de impuesto en productos [16/06/2025].
  const [toInventory, setToInventory] = useState(false)
  const [description, setDescription] = useState('')
  const [enterprises, setEnterprises] = useState([])
  const [company_id, setCompanyId] = useState('')

  const [taxProduct, setTaxProduct] = useState(null)  // Nuevo campo para controlar los imupuestos configurados.
  const [refenciaCabys, setRefenciaCabys] = useState('')
  const [selectedTaxId, setSelectedTaxId] = useState(null); // este también.
  const [allTaxes, setAllTaxes] = useState([]);
  const [filteredTaxes, setFilteredTaxes] = useState([]);


  useEffect(() => {
    if (props.visible) {
      parseCountryTaxOptions().then(() => {
        loadInfo();
      });
  
      onSearchEnterprise(props.edit ? props.editData._empresaNombre : '')
    } else {
      clear()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible])

  const onSearchEnterprise = val => {
    val !== null ? (val = '') : (val = '')

    const excludeChars = Utils.excludedCharsContent(val)
    Utils.getEnterpriseOption(val, excludeChars, 'desc')
      .then(response => {
        if (auth?.role?.id === 1) {
          response.data.data[response.data.data.length] = { id: 0, name: 'Señor tendero'}
        }
        
        setEnterprises(response.data.data)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la información de empresa')
      })
  }
  
  const serializeData = () => {
    let _product = {
      description: description,
      is_all_countries: 0,
      brand_id: brand,
      product_category_id: category,
      product_subcategory_id: subCategory,
      is_taxable: tax,
      is_inventoriable: toInventory,
      uom_id: unit,
      suggested_price: price,
      countries: country,
      // company_id: company_id,
      store_chains: Chains,
      product_active_principle_1: principle1,
      product_active_principle_2: principle2,
      product_active_principle_3: principle3,
      tax_product: taxProduct,
      referencia_cabys: refenciaCabys
    };

    // Recorro los datos pero excluyo los campos que no necesito que sean obligatorios.
    let _productWithoutPrinciples = { ..._product };
    delete _productWithoutPrinciples.product_active_principle_2;
    delete _productWithoutPrinciples.product_active_principle_3;
    delete _productWithoutPrinciples.referencia_cabys;

    let msn = Utils.isEmpty(_productWithoutPrinciples);

    console.log('Por enviar los datos ', _product);
    

    if (msn || country.length <= 0) {
      message.error(` Todos los campos son Obligatorios`)
      return false
    }

    if (props.edit) props.editButton(_product, props.editData._id)
    else props.saveButton(_product)
  }

  const clearAndClose = () => {
    clear()
    props.cancelButton()
  }

  const clear = () => {
    setUnit(null)
    setBrand(null)
    setPrinciple1(null)
    setPrinciple2(null)
    setPrinciple3(null)
    setBrands([])
    setCategory(null)
    setProductCategories([])
    setSubCategory(null)
    setProductSubCategories([])
    setCountry([])
    SetChains([])
    setPrice(0)
    setTax(true) // declaro por defecto cuando se limpia siempre mantener el valor impuesto obligatorio.
    setToInventory(false)
    setDescription('')
    setCompanyId('')
    setTaxProduct(null)
    setRefenciaCabys('')
  }

  const loadInfo = () => {
    Countries.getCountries()
      .then(c => setCountries(c.data))
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar el listado de paises')
      })

    Brands.getBrands('', true)
      .then(c => {
        setBrands(c.data.data)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar el listado de marcas')
      })

    Utils.getUoms()
      .then(c => {
        setUoms(c.data)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar el listado de unidades de medida')
      })

    chains.getChains()
    .then(c => {
      setStoreChains(c.data)
    })
    .catch(err => {
      console.log(err)
      message.error('No se pudo cargar el listado de cadenas')
    })

    Utils.getActPrinciple()
    .then(c => {
      setActPrinciple(c.data)
    })
    .catch(err => {
      console.log(err)
      message.error('No se ha podido cargar el listado de principios Activos')
    })

    if (!props.edit) {
      Product.getProductsCategories()
        .then(c => setProductCategories(c.data))
        .catch(err => {
          console.log(err)
          message.error('No se ha podido cargar el listado de categorias')
        })
    }

    if (props.edit) {

      console.log('Edit ', props.editData );
      

      setDescription(props.editData.productDescription)
      setCountry(props.editData.all_countries_id[0])
      setBrand(props.editData.brand_id)
      setPrinciple1(props.editData.pap1_id)
      setPrinciple2(props.editData.pap2_id)
      setPrinciple3(props.editData.pap3_id)
      setSubCategory(props.editData.product_subcategory_id)
      setCategory(props.editData.product_category_id)
      setPrice(props.editData.suggested_price)
      SetChains(props.editData.all_chains_id)
      setUnit(props.editData.uom_id)
      setTax(props.editData.is_taxable === 1 ? true : false)
      setToInventory(props.editData.is_inventoriable === 1 ? true : false)
      setCompanyId(props.edit ? props.editData.company_id : null)
      setTaxProduct(props.editData.tax_product); // ID del impuesto ya guardado
      setSelectedTaxId(props.editData.tax_product);
      setRefenciaCabys(props.editData.referencia_cabys)
    }
  }

  const onSearchCountry = val => {
    const excludeChars = Utils.excludedCharsContent(val)
    Utils.getCountryOption(val, excludeChars, 'desc')
      .then(response => setCountries(response.data.data))
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la información de País')
      })
  }

  const onSearChChains = val => {
    const excludeChars = Utils.excludedCharsContent(val)
    Utils.getStoreChainOption(val, excludeChars, 'desc')
      .then(response => setStoreChains(response.data.data))
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar el listado de las cadenas.')
      })
  }


  const parseCountryTaxOptions = async () => {
    try {
      const response = await Product.gettaxes('', 100, true, 'desc');
      if (response?.data?.data) {
        const parsed = response.data.data.map(d => ({
          id: d.id,
          name: `${d.country.name} - ${d.isv_percentage}%`,
          value: d.isv_percentage,
          country_id: d.country_id
        }));
        setAllTaxes(parsed);
      }
    } catch (err) {
      message.error('Error al cargar impuestos');
    }
  };
  

  const handleCountryChange = (selectedCountryId) => {
    setCountry(selectedCountryId);
    setSelectedTaxId(null);
    setTaxProduct(null);
  
    if (selectedCountryId) {
      const filtered = allTaxes.filter(t => t.country_id === selectedCountryId);
      setFilteredTaxes(filtered);
  
      if (props.edit && props.editData.tax_product) {
        const selectedTax = filtered.find(t => t.id === props.editData.tax_product);
        if (selectedTax) {
          setSelectedTaxId(selectedTax.id);
          setTaxProduct(selectedTax.id);
        }
      }
    } else {
      setFilteredTaxes([]);
    }
  };
  

  const handleCategoryChange = value => {
    setCategory(value)

    Product.getProductsSubCategories(value)
      .then(c => {
        setProductSubCategories(c.data)
        setSubCategory(null)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar el listado de subcategorías')
      })
  }

  const handleSearchBrands = value => {
    const excludeChars = Utils.excludedCharsContent(value)
    Brands.getBrands(value, excludeChars, 'desc')
      .then(c => setBrands(c.data.data))
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar el listado de marcas')
      })
  }

  const handleSearchCategory = value => {
    const excludeChars = Utils.excludedCharsContent(value)
    Product.getProductsCategories(value, excludeChars, 'desc')
      .then(c => setProductCategories(c.data))
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar el listado de categorias')
      })
  }
  
  return (
    <>
      <Drawer placement="right" closable={false} onClose={props.closable} visible={props.visible} width={800} loading={props.loading}>
        <div>
          <Title> {props.edit ? 'Editar producto' : 'Nuevo producto'} </Title>
          <Divider className={'divider-custom-margins-users'} />
          <Row gutter={16} className={'section-space-field'}>
            <Col xs={16} sm={16} md={16} lg={16}>
              <div className={'title-space-field'}>Descripción*</div>
              <Input
                value={props.edit || description !== '' ? description : ''}
                onChange={value => setDescription(value.target.value)}
                placeholder={'Descripción del nuevo producto'}
                size={'large'}
              />
            </Col>
            {/* <Col xs={8} sm={8} md={8} lg={8}>
              <GenericSelect
                title={'Empresa*'}
                data={enterprises}
                value={(props.edit || company_id !== '') && company_id !== 0 ? company_id : company_id === 0 ? 'Señor Tendero' : ''}
                handlerChange={value => setCompanyId(value)}
                placeholder={'Elegir Empresa'}
                disabled={props.edit || !enterprises}
                optionLabel={props.edit && props.editData?.enterprises?.name }
              />
            </Col> */}
            <Col xs={8} sm={8} md={8} lg={8}>
            <ChainsSelect
                title={'Cadena'}
                storeChains={props.edit || StoreChains !== [] ? StoreChains : []}
                chains={props.edit || Chains !== [] ? Chains : []}
                handleChangeChains={value => SetChains(value)}
                placeholder={'Eligir una cadena'}
                onSearchChains={onSearChChains}
              />
            </Col>
          </Row>

          <Row gutter={16} className={'section-space-field'}>
            <Col xs={8} sm={8} md={8} lg={8}>
              <GenericSelect
                title={'Países al que aplica*'}
                data={countries}
                value={props.edit || country !== '' ? country : ''}
                handlerChange={handleCountryChange}
                onSearch={debounce(onSearchCountry, 400)}
                placeholder={'Elegir país'}
                optionLabel={props.edit && props.editData?.is_all_countries?.name}
              />
            </Col>
            <Col xs={8} sm={8} md={8} lg={8}>
              <GenericSelect
                title={'Categoría*'}
                data={productCategories}
                value={props.edit || category !== '' ? category : ''}
                handlerChange={handleCategoryChange}
                onSearch={debounce(handleSearchCategory, 400)}
                placeholder={'Elegir categoría'}
                optionLabel={props.edit && props.editData?.product_category?.name}
              />
            </Col>
            <Col xs={8} sm={8} md={8} lg={8}>
              <GenericSelect
                title={'Subcategorías*'}
                data={productSubCategories}
                value={props.edit || subCategory !== '' ? subCategory : ''}
                handlerChange={value => setSubCategory(value)}
                placeholder={'Elegir Subcategoria'}
                disabled={!category}
                optionLabel={props.edit && props.editData?.product_subcategory?.name}
              />
            </Col>
          </Row>
          <Row gutter={16} className={'section-space-field'}>
            <Col xs={8} sm={8} md={8} lg={8}>
              <GenericSelect
                title={'Unidad de medida*'}
                data={uoms}
                value={props.edit || unit !== '' ? unit : ''}
                handlerChange={value => setUnit(value)}
                placeholder={'Elegir Unidad de medida'}
              />
            </Col>
            <Col xs={8} sm={8} md={8} lg={8}>
              <div className={'title-space-field'}>Precio sugerido*</div>
              <Input
                value={props.edit || price !== '' ? price : ''}
                onChange={value => setPrice(value.target.value)}
                placeholder={'Escribir un precio'}
                size={'large'}
                type={'number'}
              />
            </Col>
            <Col xs={8} sm={8} md={8} lg={8}>
              <GenericSelect
                title={'Marca*'}
                data={brands}
                value={props.edit || brand !== '' ? brand : ''}
                handlerChange={value => setBrand(value)}
                onSearch={debounce(handleSearchBrands, 400)}
                placeholder="Elegir Marca"
                optionLabel={props.edit && props.editData?.brand_name}
              />
            </Col>
          </Row>

          <Row gutter={16} className={'section-space-field'}>
            <Col xs={8} sm={8} md={8} lg={8}>
              <GenericSelect
                title={'Principio Activo 1'}
                data={ActPrinciple}
                value={props.edit || principle1 !== '' ? principle1 : ''}
                handlerChange={value => setPrinciple1(value)}
                placeholder={'Elegir primer principio activo'}
              />
            </Col>
            <Col xs={8} sm={8} md={8} lg={8}>
              <GenericSelect
                title={'Principio Activo 2'}
                data={ActPrinciple}
                value={props.edit || principle2 !== '' ? principle2 : ''}
                handlerChange={value => setPrinciple2(value)}
                placeholder={'Elegir segundo principio activo'}
              />
            </Col>
            <Col xs={8} sm={8} md={8} lg={8}>
              <GenericSelect
                title={'Principio Activo 3'}
                data={ActPrinciple}
                value={props.edit || principle3 !== '' ? principle3 : ''}
                handlerChange={value => setPrinciple3(value)}
                placeholder={'Elegir tercer principio activo'}
              />
            </Col>
           
          </Row>

          <Row gutter={16} className={'section-space-field'}>
           
            {/* Nuevo campo de impuesto */}
              <Col xs={8} sm={8} md={8} lg={8}>
              <GenericSelect
                title={'Impuesto Producto'}
                data={filteredTaxes.length > 0 ? filteredTaxes : allTaxes.filter(t => t.country_id === (Array.isArray(country) ? country[0] : country))}
                value={selectedTaxId || ''}
                handlerChange={value => {
                  const selected = allTaxes.find(item => item.id === value);
                  setTaxProduct(selected?.id || null);
                  setSelectedTaxId(value);
                }}
                onFocus={() => {
                  const currentCountryId = Array.isArray(country) ? country[0] : country;
                  const filtered = allTaxes.filter(t => t.country_id === currentCountryId);
                  setFilteredTaxes(filtered);
                }}
                placeholder={'Elegir Impuesto'}
                optionValue={'id'}
                optionText={'name'}
                optionLabel={props.edit && props.editData?.tax_display_name}
              />
              </Col>

              <Col xs={8} sm={8} md={8} lg={8}>
                <div className={'title-space-field'}>Cabys</div>
                <Input
                  value={props.edit || refenciaCabys !== '' ? refenciaCabys : ''}
                  onChange={value => setRefenciaCabys(value.target.value)}
                  placeholder={'Escribir una referencia'}
                  size={'large'}
                  type={'string'}
                />
              </Col>

          </Row>
            
          

          {/*Radio button section*/}
          <Row gutter={16} className={'section-space-list'}>
            <Col xs={12} sm={12} md={12} lg={12}>
              <span className={'label-bold-500 ratio-button-labels'}>¿Impacta inventario?</span>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Radio.Group
                className={'radio-group'}
                optionType="button"
                buttonStyle="solid"
                size={'large'}
                value={toInventory}
                onChange={value => setToInventory(value.target.value)}
              >
                <Radio.Button value={false}>No</Radio.Button>
                <Radio.Button value={true}>Sí</Radio.Button>
              </Radio.Group>
            </Col>
          </Row>

          {/* [Incio][Quito el campo de exento de impuesto de true y false][23/06/2025] */}
          {/* <Row gutter={16} className={'section-space-list'}>
            <Col xs={12} sm={12} md={12} lg={12}>
              <span className={'label-bold-500 ratio-button-labels'}>¿Excento de impuestos?</span>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Radio.Group
                className={'radio-group'}
                optionType="button"
                buttonStyle="solid"
                size={'large'}
                value={tax}
                onChange={value => setTax(value.target.value)}
              >
                <Radio.Button value={false}>No</Radio.Button>
                <Radio.Button value={true}>Sí</Radio.Button>
              </Radio.Group>
            </Col>
          </Row> */}
          {/* [FIN][Quite campo de exento de impuesto][23/06/2025] */}
        </div>
        {/*End Radio button section*/}
        <div>
          <Divider className={'divider-custom-margins-users'} />
          {/*Footer buttons section*/}
          <Row gutter={16}>
            <Col xs={24} sm={24} md={24} lg={24}>
              <div className="text-right">
                <div>
                  <Button type={'link'} className="cancel-button" onClick={clearAndClose} loading={props.loading}>
                    Cancelar
                  </Button>
                  <Button htmlType="submit" className="title-tendero new-button" onClick={serializeData} loading={props.loading}>
                    {props.edit ? 'Actualizar' : 'Guardar'}
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        {/*End Footer buttons section*/}
      </Drawer>
    </>
  )
}

export default ProductDrawer
